import React, { useState, useEffect } from "react";
import "./styles/PopupTranslate.css"; // Ajoute ce fichier pour le style

const PopupTranslate = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Vérifie si l'utilisateur a déjà vu la pop-up
    const hasSeenPopup = localStorage.getItem("hasSeenPopup");

    if (!hasSeenPopup) {
      setIsOpen(true);

      // Fermer la pop-up après 30 secondes
      const timer = setTimeout(() => {
        setIsOpen(false);
        localStorage.setItem("hasSeenPopup", "true"); // Sauvegarde l'affichage
      }, 30000); // 30 secondes

      // Nettoyage du timer si l'utilisateur ferme la pop-up avant
      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setIsOpen(false);
    localStorage.setItem("hasSeenPopup", "true"); // Sauvegarde l'affichage
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>🌍 Translation Available!</h2>
        <p>
          This website is compatible with built-in browser translation modules.
          You can view it in your preferred language using your browser's
          translation feature.
        </p>
        <button onClick={closePopup} className="close-btn">
          OK, Got it!
        </button>
      </div>
    </div>
  );
};

export default PopupTranslate;
